import { priceFormat } from "utils/format";

import { Cut } from "components/Cut";

export const tableColumns = [
  {
    dataField: "name",
    text: "Имя",
    headerStyle: (colum, colIndex) => {
      return { width: '12%' };
    },
    formatter: (cell, row) => <Cut>{cell}</Cut>,
  },
  {
    dataField: "active",
    text: "Активен",
    headerStyle: (colum, colIndex) => {
      return { width: '4%' };
    },
    formatter: cell => cell ? 'Да' : 'Нет',
  },
  {
    dataField: "orgInn",
    text: "ИНН",
    headerStyle: (colum, colIndex) => {
      return { width: '8%' };
    }
  },
  {
    dataField: "balance",
    text: "Баланс",
    headerStyle: (colum, colIndex) => {
      return { width: "7%" };
    },
    formatter: (cell) => (
      <b className={cell < 0 ? "red" : ""}>{priceFormat(cell)}</b>
    ),
    headerClasses: () => "right",
    classes: () => "right",
  },
  {
    dataField: "",
    text: "",
    headerStyle: (colum, colIndex) => {
      return { width: '20%' };
    }
  },
];